const violations = [
    {
        "uuid": "1",
        "appNo": "21122101",
        "customerNo": "0004",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "createdOn": "2021-11-10T08:20:10.000Z",
        "creator": "王小白",
        "violationTypes": ["quality"],
        "source": "externalUnit",
        "violationProductInfos": [
            {
                "product": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "plasticBottle",
                "spec": "600ml/瓶",
                "effectiveDate": "2022-12-25T08:00:00.000Z",
            },
        ],
        "unqualifiedTestItems": [
            {
                "testType": "finishedGood",
                "testItems": [
                    {"testItem": "02", "details": ["0201","0204"],}
                ],
                "testName": "Natural Benefits 食安生技-椰子汁",
                "testEffectiveDate": "2021-12-31T08:00:00.000Z",
                "violationReason": "違規原因......",
            }
        ]
    },
]

export default violations;